<template>
  <v-snackbar
    v-model="open"
    :top="true"
    :color="color"
    :timeout="type === 'download' ? -1 : 1500"
    centered
  >
    <div class="box">
      <div class="text">
        <v-icon v-show="type === 'info'" class="icon">
          {{ icons.mdiInformationOutline }}
        </v-icon>
        <v-icon v-show="type === 'success'" class="icon">
          {{ icons.mdiCheckCircleOutline }}
        </v-icon>
        <v-icon v-show="type === 'warning'" class="icon">
          {{ icons.mdiAlertOutline }}
        </v-icon>
        <v-icon v-show="type === 'error'" class="icon">
          {{ icons.mdiAlertCircleOutline }}
        </v-icon>
        <v-icon v-show="type === 'download'" class="icon-black">
          {{ icons.mdiCheckCircleOutline }}
        </v-icon>
        <span :style="type === 'download' ? 'color:#07260B' : ''">
          {{ msg }}
        </span>
      </div>
      <div>
        <v-btn
          v-if="type === 'download'"
          color="black"
          height="24"
          style="color: #07260b"
          text
          @click="open = false"
        >
          我知道了
        </v-btn>
      </div>
    </div>
  </v-snackbar>
</template>

<script>
import { ref } from 'vue'
import {
  mdiInformationOutline,
  mdiCheckCircleOutline,
  mdiAlertOutline,
  mdiAlertCircleOutline,
} from '@mdi/js'

export default {
  setup() {
    const color = ref('')
    const open = ref(false)
    const msg = ref('')
    const type = ref('info')
    const info = (_msg) => {
      color.value = 'rgba(0, 120, 214, 1)' // 'rgb(33,150,243)'
      type.value = 'info'
      msg.value = _msg
      open.value = true
    }

    const success = (_msg) => {
      color.value = 'rgba(25, 128, 37, 1)' // 'rgb(76,175,80)'
      type.value = 'success'
      msg.value = _msg
      open.value = true
    }

    const warning = (_msg) => {
      color.value = 'rgba(232, 189, 0, 1)' // 'rgb(255, 170, 0)'
      type.value = 'warning'
      msg.value = _msg
      open.value = true
    }

    const error = (_msg) => {
      color.value = 'rgba(217, 33, 33, 1)' // 'rgb(255,82,82)'
      type.value = 'error'
      msg.value = _msg
      open.value = true
    }

    const download = (_msg) => {
      color.value = '#E9F6EA'
      msg.value = _msg
      type.value = 'download'
      open.value = true
    }
    return {
      color,
      open,
      msg,
      type,

      info,
      success,
      warning,
      error,
      download,

      icons: {
        mdiInformationOutline,
        mdiCheckCircleOutline,
        mdiAlertOutline,
        mdiAlertCircleOutline,
      },
    }
  },
}
</script>
<style lang="scss" scoped>
.snackbar-white {
  color: #fff;
}
.box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .text {
    display: flex;
    align-items: center;
  }
}
.snackbar {
  color: black !important;
  font-weight: 800;
}
.icon {
  color: #fff;
  margin-right: 12px;
}
.icon-black {
  color: #198025;
  margin-right: 12px;
}
</style>
